export default __webpack_public_path__ + "static/media/ThreeDSecure.ec44bb77.yaml";